import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { SiteHeader } from '@/components/landing/site-header'
import { HeroMarathon } from '@/components/landing/hero-marathon'

const Home: FC = (): ReactNode => {
    return (
        <div id='top' className='min-h-screen bg-[#0b0b0d]'>
            <Seo />
            <SiteHeader />

            <main>
                <HeroMarathon />
            </main>
        </div>
    )
}

export default Home
